export default __webpack_public_path__ + "static/media/pike_pushups.f88fafd3.svg";